// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1StateSchema } from './stateSchema';

export const v1HourSchema = z.object({
  id: z.number().int().describe("Unique identifier for the time entry"),
  uid: z.coerce.string().describe("Unique string identifier for the time entry"),
  user: z.object({
    id: z.number().int().gt(0),
    email: z.coerce.string().min(1),
    name: z.coerce.string().min(1),
    avatar: z.object({
      large_retina: z.coerce.string().url(),
      large: z.coerce.string().url(),
      medium_retina: z.coerce.string().url(),
      medium: z.coerce.string().url(),
      small_retina: z.optional(z.coerce.string().url()),
      small: z.optional(z.coerce.string().url()),
      timeline: z.optional(z.coerce.string().url()),
    }),
    active: z.optional(z.boolean()),
    day_view_onboarded: z.optional(z.boolean()),
    memory_onboarded: z.optional(z.boolean()),
    created_at: z.string().datetime().nullish(),
    updated_at: z.string().datetime().nullish(),
    last_received_memories_date: z.string().datetime().nullish(),
    sign_in_count: z.number().int().nullish(),
    external_id: z.coerce.string().nullish(),
    time_zone: z.coerce.string().nullish(),
    memory_retention_days: z.number().int().nullish(),
    type: z.coerce.string().nullish(),
  }).describe("User who logged this time"),
  project: z.object({
    id: z.number().int(),
    active: z.boolean(),
    account_id: z.number().int(),
    name: z.coerce.string(),
    description: z.nullable(z.coerce.string()),
    color: z.coerce.string(),
    rate_type: z.coerce.string(),
    billable: z.boolean(),
    created_at: z.number().int(),
    updated_at: z.number().int(),
    external_id: z.coerce.string().nullish(),
    budget_scope: z.coerce.string().nullish(),
    client: z.object({
      id: z.number().int(),
      name: z.coerce.string(),
      color: z.coerce.string(),
      active: z.boolean(),
      external_id: z.coerce.string().nullish(),
      updated_at: z.string().datetime(),
    }),
    required_notes: z.boolean(),
    required_labels: z.boolean(),
    budget_expired_on: z.coerce.string().nullish(),
    has_recurrence: z.boolean(),
    enable_labels: z.coerce.string(),
    default_labels: z.boolean(),
    allow_only_one_tag: z.boolean(),
    currency: z.object({
      id: z.coerce.string(),
      name: z.coerce.string(),
      iso_code: z.coerce.string(),
      symbol: z.coerce.string(),
      symbol_first: z.boolean(),
    }),
    team_ids: z.array(z.number().int()),
    budget: z.number().int().nullish(),
    budget_type: z.coerce.string().nullish(),
    budget_calculation: z.coerce.string().nullish(),
    hour_rate: z.number().nullish(),
    hour_rate_in_cents: z.number().nullish(),
    budget_progress: z.number().nullish(),
    budget_percent: z.number().nullish(),
    invoice_by_budget: z.boolean().nullish(),
    labels: z.array(z.object({
      id: z.number().int(),
      name: z.coerce.string(),
      sequence: z.number().int(),
      parent_id: z.number().int().nullish(),
      emoji: z.coerce.string().nullish(),
      active: z.boolean(),
      external_id: z.coerce.string().nullish(),
      created_at: z.string().datetime().nullish(),
      updated_at: z.string().datetime().nullish(),
      tic: z.optional(z.object({
        uri: z.coerce.string(),
        tool_id: z.coerce.string().nullish(),
        external_url: z.coerce.string().nullish(),
      })),
      children: z.optional(z.array(z.unknown())),
    })),
    label_ids: z.array(z.number().int()),
    required_label_ids: z.array(z.number().int()),
    default_label_ids: z.array(z.number().int()),
    created_from: z.coerce.string(),
    cost: z.optional(z.object({
      fractional: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      amount: z.optional(z.number()),
      currency_code: z.optional(z.coerce.string().min(1)),
    })),
    estimated_cost: z.optional(z.object({
      fractional: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      amount: z.optional(z.number()),
      currency_code: z.optional(z.coerce.string().min(1)),
    })),
    billed_cost: z.optional(z.object({
      fractional: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      amount: z.optional(z.number()),
      currency_code: z.optional(z.coerce.string().min(1)),
    })),
    unbilled_cost: z.optional(z.object({
      fractional: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      amount: z.optional(z.number()),
      currency_code: z.optional(z.coerce.string().min(1)),
    })),
    duration: z.optional(z.object({
      hours: z.optional(z.number().int()),
      minutes: z.optional(z.number().int()),
      seconds: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      total_hours: z.optional(z.number()),
      total_seconds: z.optional(z.number().int()),
      total_minutes: z.optional(z.number().int()),
    })),
    estimated_duration: z.optional(z.object({
      hours: z.optional(z.number().int()),
      minutes: z.optional(z.number().int()),
      seconds: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      total_hours: z.optional(z.number()),
      total_seconds: z.optional(z.number().int()),
      total_minutes: z.optional(z.number().int()),
    })),
    billed_duration: z.optional(z.object({
      hours: z.optional(z.number().int()),
      minutes: z.optional(z.number().int()),
      seconds: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      total_hours: z.optional(z.number()),
      total_seconds: z.optional(z.number().int()),
      total_minutes: z.optional(z.number().int()),
    })),
    unbilled_duration: z.optional(z.object({
      hours: z.optional(z.number().int()),
      minutes: z.optional(z.number().int()),
      seconds: z.optional(z.number().int()),
      formatted: z.optional(z.coerce.string().min(1)),
      total_hours: z.optional(z.number()),
      total_seconds: z.optional(z.number().int()),
      total_minutes: z.optional(z.number().int()),
    })),
  }).describe("Project this time was logged to"),
  duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Actual time spent (use this for reported hours)"),
  estimated_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Planned or estimated time"),
  cost: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }).describe("Actual cost of this time entry"),
  estimated_cost: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }).describe("Estimated cost based on planned time"),
  day: z.coerce.string().describe("Date this time was logged (YYYY-MM-DD format)"),
  note: z.coerce.string().describe("Description or notes about the work performed").nullish(),
  sequence: z.number().int().describe("Order of this entry within the day"),
  estimated: z.boolean().describe("True for planned/scheduled time, false for actual logged time"),
  timer_state: z.coerce.string().describe("Timer status: running, stopped, or paused"),
  timer_started_on: z.number().int().describe("Unix timestamp when timer started (0 if not running)"),
  timer_stopped_on: z.number().int().describe("Unix timestamp when timer stopped (0 if never stopped)"),
  label_ids: z.array(z.number().int()).describe("Tags/categories applied to this entry"),
  user_ids: z.array(z.number().int()).describe("Users associated with this entry (for team entries)"),
  updated_at: z.number().int().describe("Unix timestamp of last modification"),
  created_at: z.number().int().describe("Unix timestamp when entry was created"),
  created_from: z.coerce.string().describe("Source that created this entry (web, mobile, api, etc.)"),
  updated_from: z.coerce.string().describe("Source of last update (web, mobile, api, etc.)"),
  billed: z.boolean().describe("True if this time has been invoiced to the client"),
  billable: z.boolean().describe("True if this time can be billed to the client"),
  to: z.coerce.string().describe("End time in HH:MM format (24-hour)").nullish(),
  from: z.coerce.string().describe("Start time in HH:MM format (24-hour)").nullish(),
  deleted: z.boolean().describe("True if this entry has been deleted (soft delete)"),
  hour_rate: z.number().describe("Billing rate per hour for this entry"),
  hour_rate_in_cents: z.number().int().describe("Billing rate in cents (for precise calculations)"),
  creator_id: z.number().int().describe("User who created this entry").nullish(),
  updater_id: z.number().int().describe("User who last modified this entry").nullish(),
  external_id: z.coerce.string().describe("Your system's identifier for integration mapping").nullish(),
  entry_ids: z.array(z.number().int()).describe("Memory timeline entries that make up this logged time"),
  suggestion_id: z.number().int().describe("AI suggestion that generated this entry").nullish(),
  autosheet_proposal_id: z.coerce.string().describe("AutoSheet proposal UUID this hour was created from").nullish(),
  draft: z.boolean().describe("True if this is a draft (not yet submitted)"),
  manage: z.boolean().describe("True if current user can edit/delete this entry"),
  forecast_id: z.number().int().describe("Task that this entry fulfills").nullish(),
  billed_at: z.coerce.string().describe("ISO 8601 timestamp when this was invoiced").nullish(),
  external_link_ids: z.array(z.number().int()).describe("Links to related resources (tickets, docs, etc.)"),
  internal_cost: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("Your internal cost for this work (for profit tracking)")),
  estimated_internal_cost: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("Estimated internal cost")),
  internal_cost_rate: z.number().int().describe("Internal cost rate in cents per hour"),
  profit: z.number().int().describe("Profit margin in cents (billable cost - internal cost)"),
  profitability: z.number().int().describe("Profit percentage ((profit / cost) * 100)"),
  locked_reason: z.coerce.string().describe("Why this entry is locked (e.g., \"Approved timesheet\")").nullish(),
  locked: z.boolean().describe("True if entry is locked and cannot be edited"),
  invoice_id: z.number().int().describe("Invoice this entry appears on (if billed)").nullish(),
  timestamps: z.array(z.object({
    id: z.number().int(),
    hour_id: z.number().int(),
    from: z.coerce.string(),
    to: z.coerce.string(),
    entry_ids: z.array(z.number().int()),
  })).describe("Individual time segments that make up this entry"),
  state: z.lazy(() => v1StateSchema).describe("Workflow state (for approval processes)").nullish(),
  external_links: z.array(z.object({
    provider_type: z.coerce.string(),
    provider_id: z.coerce.string(),
    external_id: z.coerce.string(),
    uri: z.coerce.string().nullish(),
    data: z.optional(z.object({})),
  })).describe("Attached links to tickets, PRs, documents, etc."),
  linked_work_items: z.array(z.object({
    id: z.coerce.string().nullish(),
    title: z.coerce.string().nullish(),
    sync_status: z.coerce.string().nullish(),
  })).describe("Linked work items from external tools. Present when include_linked_metadata=true and integrations feature is enabled.").nullish(),
});
